module.exports = __webpack_public_path__ + "static/media/cashin-logo.ae61a921.svg";